import { render } from "./UppyPhoto.vue?vue&type=template&id=103d4f0a&scoped=true"
import script from "./UppyPhoto.vue?vue&type=script&lang=js"
export * from "./UppyPhoto.vue?vue&type=script&lang=js"

import "./UppyPhoto.vue?vue&type=style&index=0&id=103d4f0a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-103d4f0a"]])

export default __exports__